import React from 'react';
import PropTypes from 'prop-types';

import { Swiper } from '../../components/global/Swiper/Swiper';
import { FullPageWidth } from '../../components/global/FullPageWidth/FullPageWidth';

import { SWIPER_TABLET_TILES_COUNT } from '../../constants/sbConstants';

// styles
import styles from './sbRespTilesSwiper.scss';

const SbRespTilesSwiper = ({ isTablet, children }) => {
    const swiperClasses = {
        wrapper: styles.swrapper,
        item: styles.item,
    };

    if (!isTablet) {
        return children;
    }

    return (
        <FullPageWidth>
            <Swiper
                classNames={swiperClasses}
                itemsPerPage={SWIPER_TABLET_TILES_COUNT}
                shouldCategoryTilesUpdate
            >
                {children}
            </Swiper>
        </FullPageWidth>
    );
};

SbRespTilesSwiper.propTypes = {
    isTablet: PropTypes.bool,
    children: PropTypes.node.isRequired,
};

export { SbRespTilesSwiper };
